module.exports = __webpack_public_path__ + "img/homepage-banner.86c758e8.jpg";